module.exports = __webpack_public_path__ + "img/cach.5443bc35.png";